import React from "react";
import { useOutletContext } from "react-router-dom";

const CompanyInfo = () => {
  const data = useOutletContext();

  if (!data) return <div>Loading...</div>;

  const renderDetailItem = (label, value) => (
    <div className="detail-item">
      <div className="detail-label">{label}</div>
      <div className="detail-value">{value || "N/A"}</div>
    </div>
  );

  return (
    <div>
      {/* Personal Details Section */}
      <div className="section borderLight">
        <h2>Personal Details</h2>
        <div className="details-grid">
          {renderDetailItem("First Name", data.ceoName?.split(" ")[0] || "N/A")}
          {renderDetailItem("Last Name", data.ceoName?.split(" ")[1] || "N/A")}
          {renderDetailItem("Email Address", data.email || "N/A")}
          {renderDetailItem("Country", data.address?.split(",")[data.address?.split(",").length - 1]?.trim() || "N/A")}
        </div>
      </div>

      {/* Company Details Section */}
      <div className="section borderLight">
        <h2>Company Details</h2>
        <img
          src={data.logo}
          alt="Company Logo"
          className="company-logo"
        />

        <div className="company-details">
          <div className="details-grid">
            {renderDetailItem("Industry Classification", data.industry || "N/A")}
            {renderDetailItem("Industry Expertise", data.specifyIndustry || "N/A")}
            {renderDetailItem("Company Name", data.name || "N/A")}
            {renderDetailItem("Company Website", data.website || "N/A")}
            {renderDetailItem("Company Email", data.email || "N/A")}
            {renderDetailItem("Phone", data.phone || "N/A")}
            {renderDetailItem("LinkedIn Profile URL", data.linkedinUrl || "N/A")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
